
import { useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'

interface UseQuizzesRealtimeProps {
  onQuizzesChange: () => void
  onQuizAttemptsChange: () => void
}

export const useQuizzesRealtime = ({ onQuizzesChange, onQuizAttemptsChange }: UseQuizzesRealtimeProps) => {
  useEffect(() => {
    // Real-time subscription for quizzes changes
    const quizzesChannel = supabase
      .channel('quizzes-realtime-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'quizzes'
        },
        () => {
          console.log('Quizzes changed - refreshing data')
          onQuizzesChange()
        }
      )
      .subscribe()

    // Disabled quiz attempts real-time subscription due to RLS policy conflicts
    // The subscription was causing 406 errors when trying to access quiz_attempts
    // without proper authentication context
    console.log('Quiz attempts real-time subscription disabled to prevent RLS errors')

    return () => {
      supabase.removeChannel(quizzesChannel)
      // No need to remove attemptsChannel since it's not created
    }
  }, [onQuizzesChange, onQuizAttemptsChange])
}
